import React from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import ReactPlayer from 'react-player';
import './index.css';
import { setgmailAddOnFromMarketPlace } from '../../../../../../../actions/profileActions';
import {withRouter} from 'react-router-dom';

class GmailAddOnTutorial extends React.PureComponent {

  opengsc = () => {
    let keysToRemove = ['gmailAddOnFromMarketPlace', 'gmailAddOnFromDrive', 'gmailAddOnFromCalendar'];
				keysToRemove.forEach(k =>
					localStorage.removeItem(k))
    this.props.setgmailAddOnFromMarketPlace('');
  };

  redirecToSource = (checkLandingSite) => {
    let keysToRemove = ['gmailAddOnFromMarketPlace', 'gmailAddOnFromDrive', 'gmailAddOnFromCalendar'];
    keysToRemove.forEach(k =>
      localStorage.removeItem(k))
      if(checkLandingSite==='GSC_DRIVE_ADDON'){
        window.location.href =
      'https://drive.google.com/?authuser=' + this.props.profile.email;
      } else if(checkLandingSite==='GSC_CALENDAR_ADDON'){
        window.location.href =
      'https://calendar.google.com/calendar/?authuser=' + this.props.profile.email;
      } else  {
        window.location.href =
      'https://mail.google.com?authuser=' + this.props.profile.email;
    }
  };

  render() {
    let textFromLandingSite = ''
    let landingSiteValue = ''
    if(localStorage.getItem('gmailAddOnFromDrive')){
      landingSiteValue = 'GSC_DRIVE_ADDON'
      textFromLandingSite = this.props.t("textGmailAddOnMarketPlace2")
    } else if(localStorage.getItem('gmailAddOnFromCalendar')){
      landingSiteValue = 'GSC_CALENDAR_ADDON'
      textFromLandingSite = this.props.t("textGmailAddOnMarketPlace3")
    } else {
      landingSiteValue = 'GSC_ADDON'
      textFromLandingSite = this.props.t("textGmailAddOnMarketPlace4")
    }
    
    return (
      <div id='parent'>
        <div id='sub-parent'>
          <ReactPlayer
            controls
            url='https://www.youtube.com/watch?v=xoZU0-N1IL0'
          />
          <div>
            <button className='btn-add-on' onClick={() => this.redirecToSource(landingSiteValue)}>
              <div className='btn-add-on-sub-div-first'>
                <div className='btn-add-on-sub-div-second'>
                  <img
                    className='myimggmail'
                    src={landingSiteValue === 'GSC_DRIVE_ADDON'?`/img/Google_Drive_icon_.svg.png`:landingSiteValue === 'GSC_CALENDAR_ADDON'? `/img/calendar_add_on.png`: `/img/gmail-logo.png`}
                    alt=''
                  />
                </div>
                <div
                  style={{
                    display: 'flex',
                    flex: 1,
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: 'white',
                    fontWeight: 'bold',
                  }}
                >
                 {textFromLandingSite}
                </div>
              </div>
            </button>
            <button
              className='btn-add-on-gsc'
              style={{ marginBottom: 10 }}
              onClick={this.opengsc}
            >
              <div className='btn-add-on-sub-div-gsc'>
                <img
                  className='myimggsc'
                  src={`/img/gsc.svg`}
                  alt=''
                />
                <div className='btn-sharing-contact'>
                  {this.props.t("textGmailAddOnMarketPlace1")}
                </div>
              </div>
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    profile: state.profileReducer.getProfile,
    selectedContactsGroup:
      state.contactsGroupItemReducer.getSelectedContactsGroup,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setgmailAddOnFromMarketPlace: (string) => {
      dispatch(setgmailAddOnFromMarketPlace(string));
    },
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(GmailAddOnTutorial)));
